import React, { useState } from 'react';
import { Button, Modal, Input } from 'antd';


import { useEffect } from 'react';

const { TextArea } = Input;

const InputText = () => {
  const [taskObj, setTaskObj] = useState({
    taskName: '',
    taskDescript: '',
    date: '',
  });
  useEffect(() => {
    console.log('taskobj', taskObj);
  }, [taskObj, setTaskObj]);

  return (
    <>
      <Input
        name="task_name"
        key={'task_name'}
        placeholder="Add task name"
        type="text"
        value={taskObj.taskName}
        onChange={(e) => setTaskObj({ ...taskObj, taskName: e.target.value })}
      />
      <TextArea
        key={'task_desc'}
        placeholder="Add description"
        onChange={(e) =>
          setTaskObj({ ...taskObj, taskDescript: e.target.value })
        }
        value={taskObj.taskDescript}
      ></TextArea>
    </>
  );
};

const AddTaskModel = ({ setIsModalOpen, isModalOpen }) => {
  const [btn_index, setBtn_index] = useState(1);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const AddTaskName = () => {
    return (
      <>
        <InputText />

        <br></br>
      </>
    );
  };
  const btn_span = {
    display: 'flex',
    justifyContent: 'space-between',
  };

  return (
    <Modal
      title="ADD TASK"
      open={isModalOpen}
      //onOk={handleOk}
      onCancel={handleCancel}
    >
      <AddTaskName />
      <br />
      <br />
      <div style={btn_span}>
        {btn_index !== 1 && (
          <Button
            style={{ borderRadius: '12px' }}
            onClick={() => setBtn_index(btn_index - 1)}
          >
            ◀Previous
          </Button>
        )}
        {btn_index !== 3 && (
          <Button
            style={{ borderRadius: '12px' }}
            onClick={() => setBtn_index(btn_index + 1)}
            disabled={btn_index === 3 ? true : false}
          >
            Next ▶
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default AddTaskModel;
